/**
 * @prettier
 */
export class JSONSchemaIsExpandedState {
  static Collapsed = "collapsed"

  static UserCollapsed = "user-collapsed"

  static Expanded = "expanded"

  static DeeplyExpanded = "deeply-expanded"
}
